import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2DownloadIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 16),
    children: [/*#__PURE__*/jsx("path", {
      d: "m8 .5v10.77"
    }), /*#__PURE__*/jsx("path", {
      d: "m3.961 7.351 4.039 4.039 4.039-4.039"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.5 11.461v1.346c0 1.487-.9 2.692-2 2.692h-11c-1.1 0-2-1.205-2-2.692v-1.346"
    })]
  });
};

export { PM2DownloadIcon };
//# sourceMappingURL=download.js.map
